import { RouteHandler } from 'wee-routes';
import { _body, _win } from 'core/variables';
import $ from 'wee-dom';
import $events from 'wee-events';
import $location from 'wee-location';
import $fetch from 'wee-fetch';

class Form {
    constructor() {
        this.$body = $(_body);
        this.specialty = $(':specialtyDropdown');
        this.service = $(':serviceDropdown');
        this.doctor = $(':doctorDropdown');
        this.reset = $(':resetForm');
        this.submit = $(':submitForm');
        this.form = $(':form');
        this.basePath = $location.uri().origin;
        this.query = $location.uri().query;
        this.hasQuery = Object.keys(this.query).length;
        this.section = Object.keys(this.query)[0];
        this.queryId = this.query[this.section];
        this.specialtyId = 'specialty';
        this.serviceId = 'service';
        this.doctorId = 'doctor';
    }

    /*
        Doctors are related on the doctor entry, but services are related on the specialty page,
        so we have to tell element-api to use targetElement or sourceElement for the relation
    */
    getSpecialties(element) {
        $fetch.get(`${this.basePath}/specialties/${element}/${this.queryId}.json`)
            .then(({ data }) => {
                this.buildSpecialties(this.sort(data.data));
            }).catch((error) => {
                console.error(error);
            });
    }

    getServices() {
        $fetch.get(`${this.basePath}/services/${this.specialtyId}/${this.doctorId}.json`)
            .then(({ data }) => {
                this.showServices();

                this.buildServices(this.sort(data.data));

                if (this.section !== 'personnel') {
                    this.getDoctors();
                }
            }).catch((error) => {
                console.error(error);
            });
    }

    getDoctors() {
        $fetch.get(`${this.basePath}/doctors/${this.specialtyId}/${this.serviceId}.json`)
            .then(({ data }) => {
                this.buildDoctors(this.sort(data.data));
            }).catch((error) => {
                console.error(error);
            });
    }

    showServices() {
        $(':services')
            .show()
            .parent('.-hidden')
            .removeClass('-hidden');
    }

    buildSpecialties(specialties) {
        let specialtyOptions = `
            <option selected disabled>Select a Specialty</option>
            <option value="Not sure" data-ref="specialty">Not Sure</option>
        `;

        specialtyOptions += this.mapOptions(specialties);

        this.specialty.html(specialtyOptions);
    }

    buildServices(services) {
        let serviceOptions = `
            <option selected disabled>Select a Service</option>
            <option value="Not sure" data-ref="service">Not Sure</option>
        `;

        serviceOptions += this.mapOptions(services) + '<option value="other" data-ref="service">Other</option>';

        this.service.html(serviceOptions);
    }

    buildDoctors(doctors) {
        let doctorOptions = '<option value="No Preference" data-ref="doctor">No Preference</option>';

        doctorOptions += this.mapOptions(doctors);

        this.doctor.html(doctorOptions);
    }

    mapOptions(obj) {
        let options = obj.map(item => `<option value="${item.title}" data-ref="${item.id}">${item.title}</option>`);

        return options;
    }

    sort(options) {
        let sortedOptions = options.slice(0);

        sortedOptions.sort((a,b) => {
            return (a.title > b.title) ? 1 : ((b.title> a.title) ? -1 : 0);
        });

        return sortedOptions;
    }

    prefill() {
        const $option = $(`:${this.queryId}`);

        if (this.section === 'specialties') {
            this.specialtyId = this.queryId;
            this.getServices();
            $(':default', this.specialty).removeAttr('selected');
        } else if (this.section === 'services') {
            this.serviceId = this.queryId;
            this.showServices();
            this.getSpecialties('targetElement');
            this.getDoctors();
            $(':default', this.service).removeAttr('selected');
        } else if (this.section === 'personnel') {
            this.doctorId = this.queryId;
            this.getSpecialties('sourceElement');
            this.getServices();
            this.showServices();
            $(':default', this.doctor).removeAttr('selected');
        }

        $option.prop('selected', true);
    }

    resetForm() {
        this.specialty.removeAttr('disabled');
        this.service.removeAttr('disabled');
        this.doctor.removeAttr('disabled');

        this.specialtyId = 'specialty';
        this.serviceId = 'service';
        this.doctorId = 'doctor';
        this.queryId = 'all';
        this.section = '';

        this.getSpecialties('sourceElement');
        this.getServices();
        this.getDoctors();

        this.form[0].reset();
    }
}

export default new RouteHandler({
    init() {
        const form = new Form();

        if (form.hasQuery) {
            form.prefill();
        }

        $events.on({
            [form.specialty.sel]: {
                change(e, el) {
                    form.specialtyId = $(el.options[el.selectedIndex]).data('ref');

                    if (form.section == 'personnel') {
                        form.getServices();
                    } else if (form.section !== 'services') {
                        form.getServices();
                    }
                }
            },
            [form.service.sel]: {
                change(e, el) {
                    form.serviceId = $(el.options[el.selectedIndex]).data('ref');

                    if (form.section !== 'personnel') {
                        form.getDoctors();
                    }
                },
            },
            [form.reset.sel]: {
                click(e) {
                    if (_win.confirm('Are you sure you want to reset this form?')) {
                        e.preventDefault();
                        form.resetForm();
                    } else {
                        e.preventDefault();
                    }
                }
            }
        });
    }
})
